
import SelfVerification from "../selfverification";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { Loading } from "../layout/loading";
import { RootState } from "../../store/types/rootState";
import { useLazyGetLastActiveRaffleQuery } from "../../store/api";
import { NoActiveRaffle } from "../home/NoActiveRaffle";
import { RaffleCatalog } from "../home/RaffleCatalog";
import { usePublicRaffle } from "../../store/hooks/usePublicRaffle";
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";



export const SelfVerificationPage = () => {
    const { email } = useParams<{ email: string }>();
    const [searchParams] = useSearchParams();
    const raffleId = searchParams.get("raffleId");

    const accountId = useAppSelector(
      ({ account }: RootState) => account.id,
    );


    const logo = useAppSelector(
      ({ account }: RootState) => account.logo,
    );

    const { raffle: activeRaffleFounded, needsSelection, isLoading: isLoadingGetActiveRaffle, error: errorGetActiveRaffle, isUninitialized } = usePublicRaffle(raffleId);

    const [findLastRaffleQuery, { data: lastActiveRaffleFounded, isLoading: isLoadingGetlastActiveRaffle, error: errorGetLastActiveRaffle }] = useLazyGetLastActiveRaffleQuery();

    // Sin raffleId, si la cuenta no tiene rifa activa se muestra la última cerrada
    useEffect(() => {
      if (errorGetActiveRaffle && !raffleId) {
        findLastRaffleQuery(accountId)
      }
    }, [errorGetActiveRaffle])

    if (needsSelection && email) {
      return <RaffleCatalog title="¿Qué rifa quieres revisar?" getHref={(raffle) => `/self-verification/${encodeURIComponent(email)}?raffleId=${raffle.id}`} />;
    }

    const notFound = raffleId ? !activeRaffleFounded : errorGetLastActiveRaffle && errorGetActiveRaffle;

    return !isLoadingGetActiveRaffle && !isUninitialized ? (
      <>
        {activeRaffleFounded && email && <SelfVerification limit={activeRaffleFounded.limit} email={email} raffleId={activeRaffleFounded.id} activeRaffleName={activeRaffleFounded.name} raffleType={activeRaffleFounded.type} /> }
        {!raffleId && lastActiveRaffleFounded && email && <SelfVerification limit={lastActiveRaffleFounded.limit} email={email} raffleId={lastActiveRaffleFounded.id} activeRaffleName={lastActiveRaffleFounded.name} raffleType={lastActiveRaffleFounded.type} />}
        {notFound && <NoActiveRaffle logo={logo}  />}
      </>
    ) : <Loading title="Buscando rifas disponibles"></Loading>;
}
